module.exports = __webpack_public_path__ + "static/turtle-creek-house45-6863764bc3c9101ed1baa0994d8b164f.jpg";